import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
import { Membro } from 'src/app/modules/_models/membro';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { UploadFilesService } from 'src/app/modules/_services/upload-files.service';

@Component({
  selector: 'app-desktop-sidebar',
  templateUrl: './desktop-sidebar.component.html',
  styleUrls: ['./desktop-sidebar.component.scss'],
})
export class DesktopSidebarComponent implements OnInit {
  public menuItems = [
    // {
    //   imgIcon: 'assets/images/icons/desconto_monocromatico.png',
    //   label: 'Descontos \n para  Lovers',
    //   link: '/descontosparalovers',
    // },
    // {
    //   imgIcon: 'assets/images/icons/experiencias_monocromatico.png',
    //   label: 'Minhas \n experiências',
    //   onClick: () => {
    //     window.open('https://www.chocotour.com.br/', '_blank');
    //   },
    // },
  ];

  regConfigImagemPerfil: FieldConfig[] = [];
  regConfigDadosMembro: FieldConfig[] = [];
  regConfigProximoNivel: FieldConfig[] = [];
  regConfigDesafios: FieldConfig[] = [];

  membro: Membro;

  public carregandoPerfil: boolean = false;

  constructor(
    private router: Router,
    private uploadFilesService: UploadFilesService,
    private sanitizer: DomSanitizer,
    private fidelidade: FidelidadeService
  ) {}
  ngOnInit(): void {
    this.carregarConfiguracoes();
    this.carregarDesafios();
  }

  retornarImagemPerfil() {
    if (
      this.membro.caminhoFoto != '' &&
      this.membro.caminhoFoto != null &&
      this.membro.caminhoFoto != undefined
    )
      return this.membro.caminhoFoto;
    else return 'assets/images/chocomonstros/monstro1.png';
  }

  carregarConfiguracoes(): void {
    var self = this;

    this.carregandoPerfil = true;

    this.fidelidade.obterMembro().subscribe(
      (res: any) => {
        this.membro = res;

        const userName: string = res.nome ? res.nome : 'Não identificado';
        const nivel = res.descricaoNivel
          ? res.descricaoNivel
          : 'Não identificado';

        const porcentagemNivel = res.nivelRange.porcentagemNivel;
        const pontosProximoNivel = res.nivelRange.proximoXP
          ? res.nivelRange.proximoXP
          : res.nivelRange.xpAnterior;
        const saldoXP = res.saldo.saldoXP;
        const descricaoProximoNivel = res.nivelRange.proximoXPDescricao;
        const pontosRestantes = res.nivelRange.pontosRestantesProximoNivel;

        const xpLabel: string =
          pontosRestantes != 0
            ? 'Alcance o nível ' +
              descricaoProximoNivel +
              '\nacumulando mais ' +
              pontosRestantes +
              ' nibs.'
            : 'Meus parabéns!!!\nVocê atingiu o nível máximo.';

        this.regConfigImagemPerfil = [
          {
            type: 'circleProgress',
            circleProgress: {
              imageSrc: this.retornarImagemPerfil(),
              sizeStroke: 12,
              color: 'var(--circle-progress-nivel-background-color)',
              value: 0,
              exibeTrufa: false,
              onClick: () => {
                self.router.navigate(['/meusdados']);
              },
            },
            styleDivPrincipal(): object {
              return {
                width: '102px',
              };
            },
          },
        ];
        this.regConfigDadosMembro = [
          {
            type: 'label',
            label: 'Olá, ' + userName.split(' ')[0].toUpperCase(),
            style(): object {
              return {
                'font-weight': '600',
                'font-size': '20px',
                color: '461F1A',
                'margin-top': '16px',
              };
            },
            onClick(): void {},
          },
          // {
          //   type: 'label',
          //   label: nivel,
          //   style(): object {
          //     return {
          //       'font-size': '15px',
          //       color: '#461F1A',
          //     };
          //   },
          //   onClick(): void {},
          // },
        ];
        this.regConfigProximoNivel = [
          // {
          //   type: 'label',
          //   label: xpLabel,
          //   style(): object {
          //     return {
          //       width: '60%',
          //       'text-align': 'right',
          //       'font-size': '14px',
          //     };
          //   },
          // },
          // {
          //   type: 'circleProgress',
          //   circleProgress: {
          //     value: saldoXP,
          //     maxValue: pontosProximoNivel,
          //     porcent: 0,
          //     radius: 40,
          //     // 'sizeStroke': 12,
          //     exibeLegenda: true,
          //     backgroundColor: '#ffffff',
          //     color: 'var(--circle-progress-nivel-background-color)',
          //   },
          //   styleDivPrincipal(): object {
          //     return {
          //       'margin-top': '-70px',
          //       width: '102px',
          //       'margin-left': 'calc(60% + 20px)',
          //       // 'float': 'right',
          //     };
          //   },
          // },
        ];
        this.carregandoPerfil = false;
      },
      (err: any) => {
        console.error(
          'Desktop-sidebar => carregarConfiguracoes(): Ocorreu um erro.' + err
        );
        this.carregandoPerfil = false;
      }
    );
  }

  carregarDesafios() {
    this.regConfigDesafios = [
      {
        type: 'label',
        label: 'Desafios',
        style: () => {
          return {
            'font-size': '1.1em',
            'font-weight': '700',
            color: '#A08763',
          };
        },
      },
      {
        type: 'desafiosCarousel',
        desafio: {
          exibirDesafioCompleto: true,
          exibirDesafioIncompleto: true,
          exibirSaibaMais: true,
        },
      },
    ];
  }

  transform(): Observable<any> {
    return this.uploadFilesService.getPhotoProfile().pipe(
      map((res) => {
        if (res.base64 == undefined)
          return this.sanitizer.bypassSecurityTrustResourceUrl(
            'assets/images/others/perfil_default.png'
          );
        else
          return this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/jpeg;base64,' + res.base64
          );
      })
    );
  }

  acessarPagina(item: any): void {
    if (item.link) {
      this.router.navigate([item.link]);
    } else if (item.onClick) {
      item.onClick();
    }
  }

  formatarPathIcone(path: string): string {
    return `assets/images/${path}`;
  }
}
